import {Component, inject, input, OnInit, output} from '@angular/core'
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms'
import {MatError, MatFormField, MatLabel} from '@angular/material/form-field'
import {MatInput} from '@angular/material/input'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'
import {switchMap} from 'rxjs/operators'
import {ContactInfo, StaticDataService} from '../../../services/static-data.service'

@Component({
  selector: 'spb-email-and-phone',
  templateUrl: './email-and-phone.component.html',
  styleUrls: ['./email-and-phone.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError
  ]
})
export class EmailAndPhoneComponent implements OnInit {
  public readonly index = input(0)

  public readonly formStatusChanged = output<boolean>()

  public form = new FormGroup({
    email: new FormControl<string>('', {
      validators: [Validators.email],
      updateOn: 'blur'
    }),
    mobile: new FormControl<string>('',
      {
        validators: [Validators.pattern(/^[\d\s+()-]{8,20}$/)],
        updateOn: 'blur'
      })
  })

  private readonly staticDataService = inject(StaticDataService)

  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  public ngOnInit(): void {
    this.staticDataService.contactInfo$
      .pipe(this.takeUntilDestroyed())
      .subscribe((value: [ContactInfo, ContactInfo]) => {
        if (value?.[this.index()]) {
          this.form.patchValue(value[this.index()])
        }
      })

    let newVal: any
    this.form.valueChanges.pipe(
      switchMap((val: any) => {
        newVal = val
        return this.staticDataService.contactInfo$
      }),
      this.takeUntilDestroyed()
    ).subscribe((contactInfo: ContactInfo[]) => {
      // Tells the sign button if the form is valid
      this.formStatusChanged.emit(this.form.valid)

      // Hmm is this smart or crazy? We directly assign data to the object
      // instead of modifying it and return a new one
      if (contactInfo?.[this.index()]) {
        Object.assign(contactInfo[this.index()], newVal)
      }
    })
  }
}
